import * as React from "react";

import { Link, useNavigate, useParams } from "react-router-dom";
import { RiArrowLeftLine } from "react-icons/ri";

import Paper from "../../Components/Paper";

import axiosInstance from "../../Api/Axios";

import { useLoader } from "../../Context/LoaderContext";

import "./DetailsClaim.scss";

const DetailsClaim = () => {
  const [detailsClaim, setDetailsClaim] = React.useState([]);

  const { id } = useParams();
  const navigate = useNavigate();
  const { setIsLoading } = useLoader();

  React.useEffect(() => {
    setIsLoading(true);

    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/reclamations/${id}`)
      .then((response) => {
        setIsLoading(false);
        const data = response.data.data || {};
        setDetailsClaim(data);
      })

      .catch(() => {
        setIsLoading(false);
        navigate("/list-claim");
      });
  }, [id, navigate, setIsLoading]);

  return (
    <>
      <div className="back-home">
        <Link to="/list-claim" className="link-back">
          <RiArrowLeftLine />
        </Link>
      </div>
      <h1>Détails Réclamation</h1>
      <Paper>
        {detailsClaim.reclamation_type && (
          <p>
            <span className="bold">Type de réclamation: </span>
            {detailsClaim.reclamation_type.name}
          </p>
        )}
        {detailsClaim.created_at && (
          <p>
            <span className="bold">Date de création: </span>
            {detailsClaim.created_at}
          </p>
        )}
        {detailsClaim.message && (
          <p>
            <span className="bold">Message: </span>
            {detailsClaim.message}
          </p>
        )}
        {detailsClaim.comment && (
          <p>
            <span className="bold">Commentaire: </span>
            <div
              dangerouslySetInnerHTML={{
                __html: detailsClaim.comment.description,
              }}
            />
          </p>
        )}
      </Paper>
    </>
  );
};

export default DetailsClaim;
